import Tooltip from '@material-ui/core/Tooltip';
import React from 'react';

import FilePreviewer from '@components/FilePreviewer';

import { getShortName, onUploadFile, validateFloatNumber } from '@utils/Util';

const BlPaymentInfo = ({
	data,
	onChangePaymentInfo,
	onUpdatePaymentInfo,
	onUploadPaymentDoc,
	onDeletePaymentDoc,
	type
}) => {
	return (
		<>
			<div className="one-half">
				<div className="payments-info-container">
					<div className="left-side">
						<div className="title medium-16">{type}</div>
						<div className="actual-date">
							<p className="regular-14 gray_dark_01 mb-2">Actual payment date</p>
							<input
								type="date"
								name="actualPaymentDate"
								value={data?.actualPaymentDate ?? ''}
								onChange={(e) => onChangePaymentInfo(e)}
								onBlur={onUpdatePaymentInfo}
							/>
						</div>
					</div>
					<div className="right-side">
						<div className="single-info">
							<div className="info-label">
								<p>Commercial invoice</p>{' '}
							</div>
							<div className="amount">
								<p>${data?.commercialInvoiceAmount}</p>
							</div>
						</div>
						<div className="single-info">
							<div className="info-label">
								<p className="weight-500 gray_dark_01">
									Actual {`${type === 'FACTORY' ? 'payment' : 'received'}`}
								</p>
							</div>
							<div className="amount">
								<input
									type="number"
									placeholder="$00,000.00"
									name="actualPayment"
									value={data?.actualPayment ?? ''}
									min={0}
									onChange={(e) => onChangePaymentInfo(e)}
									onBlur={onUpdatePaymentInfo}
									onKeyPress={validateFloatNumber}
								/>
							</div>
						</div>
						<div className="single-info">
							<div className="info-label">
								<p className="gray_dark_01">Deficit/Short</p>
							</div>
							<div className="amount">
								<p>${data?.deficit}</p>
							</div>
						</div>
						<div className="single-info">
							<div className="info-label">
								<p>Claim</p>
							</div>
							<div className="amount">
								<input
									type="number"
									placeholder="$00,000.00"
									name="claim"
									value={data?.claim ?? null}
									min={0}
									max={data?.deficit}
									onChange={(e) => onChangePaymentInfo(e)}
									onBlur={onUpdatePaymentInfo}
									onKeyPress={validateFloatNumber}
								/>
							</div>
						</div>
						<div className="single-info">
							<div className="info-label">
								<p>Bank charges</p>
							</div>
							<div className="amount">
								<p>${data?.bankCharge}</p>
							</div>
						</div>
						<div className="remarks">
							<textarea
								name="remarks"
								placeholder="Remarks"
								value={data?.remarks ?? ''}
								onChange={(e) => onChangePaymentInfo(e)}
								onBlur={onUpdatePaymentInfo}
							/>
						</div>
					</div>
				</div>
				<div className="upload-document-details">
					<div className="upload-doc text-center">
						<label htmlFor={`doc-upload-${type}`} className="drag-upload">
							<img src={`${process.env.PUBLIC_URL}/icons/upload-sm.svg`} alt="upload" />{' '}
							<span>Document</span>
						</label>
						<input
							type="file"
							className="file-upload d-none"
							onChange={(e) =>
								onUploadFile(
									{ ...e, id: data.id },
									'ACCESSORIES_DESIGN',
									onUploadPaymentDoc,
									'MULTI'
								)
							}
							accept="*"
							name={`doc-upload-${type}`}
							id={`doc-upload-${type}`}
						/>
					</div>
					<div className="uploded-documents pt-2">
						{data?.documentResponseList?.map((item) => (
							<div className="single-uploaded-doc d-flex align-items-center" key={item?.id}>
								<div className="doc-names">
									<FilePreviewer docUrl={item?.docUrl} />
									<Tooltip title={item?.name} placement="top" arrow>
										<a
											target="_blank"
											href={item?.docUrl}
											className="regular-12 primary_bright_01 cursor-pointer"
											rel="noreferrer"
										>
											{getShortName(item?.name, 15)}
										</a>
									</Tooltip>
								</div>
								<div className="delete-btn">
									<img
										src={`${process.env.PUBLIC_URL}/icons/delete_gray.svg`}
										alt="delete"
										onClick={() => onDeletePaymentDoc(data.id, item.id)}
									/>
								</div>
							</div>
						))}
					</div>
				</div>
			</div>
		</>
	);
};

export default BlPaymentInfo;
